import { html, nothing } from "lit";
import "../Link/index.js";
import "../../atom/Icon/index.js";
import "../IconButton/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { getIcon, getClasses, getIconClasses } from "./utils.js";
import { TestingAttrs } from "./banner.selectors.js";
import { testingAttr } from "../../../directives/testingAttr.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfBanner = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_level = "default";
    this.disabled = false;
    this.dsf_dismissible = false;
  }
  handleCtaClick(e) {
    this.emit({ name: "call-to-action", payload: e });
  }
  handleDismissClick(e) {
    this.emit({ name: "dismiss", payload: e });
  }
  render() {
    const iconName = this.dsf_icon || getIcon(this.dsf_level);
    const classes = getClasses(this);
    return html`
      <div class="${classes}" data-skeleton>
        <div class="flex flex-auto gap-12">
          <dsf-icon class=${getIconClasses(this)} dsf_name="${iconName}"></dsf-icon>
          <div class="flex flex-auto flex-col gap-4 overflow-hidden">
            ${this.dsf_title && html`<span class="dsf-text-xs-semibold break-words">${this.dsf_title}</span>`}
            <slot class="break-words"></slot>
          </div>
          ${this.dsf_dismissible ? html`<dsf-icon-button
                class="-ml-4 -mr-4 -mt-4"
                dsf_icon="X"
                dsf_size="small"
                ?disabled=${this.disabled}
                @click=${this.handleDismissClick}
                ${testingAttr(TestingAttrs.closeIcon)}
              ></dsf-icon-button>` : nothing}
        </div>
        ${this.dsf_call_to_action && !this.disabled ? html`<dsf-link
              dsf_size="medium"
              class="ml-28 mt-4 w-fit"
              @click=${this.handleCtaClick}
              ${testingAttr(TestingAttrs.ctaLink)}
              >${this.dsf_call_to_action}</dsf-link
            >` : nothing}
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: String, reflect: true })
], DsfBanner.prototype, "dsf_level", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfBanner.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String })
], DsfBanner.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfBanner.prototype, "dsf_call_to_action", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfBanner.prototype, "dsf_dismissible", 2);
__decorateClass([
  prop({ type: String })
], DsfBanner.prototype, "dsf_icon", 2);
DsfBanner = __decorateClass([
  defineElement("dsf-banner")
], DsfBanner);
export {
  DsfBanner
};
